import { useState } from 'react';
import { Select, Checkbox } from 'antd';

import useTranslation from 'customHooks/translate';

import { CustomTagRender } from './CustomTagRender';

interface OptionsProps {
  value: string;
  label: string;
}

interface IProps {
  title: string;
  options: OptionsProps[];
  onChange: (values: any[]) => void;
}

export const ReportsMultiSelect = ({ title, options, onChange }: IProps) => {
  const translation = useTranslation();
  const [selectedItems, setSelectedItems] = useState<string[]>([]);

  const handleChange = (values: string[]) => {
    if (values.includes('all')) {
      const allValues = options.map((option) => option.value);
      setSelectedItems(allValues);
      onChange([]);
    } else {
      setSelectedItems(values);
      onChange(values);
    }
  };

  return (
    <div className="flex flex-col gap-[12px]">
      <p className="text-[14px] font-semibold text-[#1D1D1D] md:text-[16px]">
        {title}
      </p>
      <Select
        tagRender={CustomTagRender}
        dropdownStyle={{ zIndex: 2000 }}
        mode="multiple"
        showSearch
        optionFilterProp="label"
        filterOption={(input, option: any) =>
          option?.label?.toLowerCase()?.includes(input?.toLowerCase())
        }
        placeholder={translation.reports.PleaseChooseOption}
        size="small"
        onChange={handleChange}
        value={selectedItems}
        maxTagCount={3}
        maxTagPlaceholder={(omittedValues) => (
          <div className="border-1 rounded-[8px] border-[#91caff] bg-[#E6F4FF] px-[8px] py-[2px] font-medium text-[#1677ff]">
            +{omittedValues.length} more
          </div>
        )}
        dropdownRender={(menu) => (
          <>
            <Checkbox
              style={{ marginLeft: '12px' }}
              indeterminate={
                selectedItems.length > 0 &&
                selectedItems.length < options.length
              }
              onChange={(event) =>
                handleChange(event.target.checked ? ['all'] : [])
              }
              checked={selectedItems.length === options.length}
            >
              {translation.reports.AllOptions}
            </Checkbox>
            {menu}
          </>
        )}
      >
        {options?.map((option) => (
          <Select.Option
            key={option.value}
            value={option.value}
            label={option?.label}
          >
            <Checkbox
              style={{ marginRight: '7px' }}
              checked={selectedItems.includes(option.value)}
            />
            {option.label}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};
